// We Like Bikes — Biomechanik-Fitting-Engine (Geometrie & Rahmengröße)
// Pure JS. Exposes window.WLB_FIT.
//
// Kalibriert gegen die Referenz-Fälle der Strategie-Guide:
//   Caso A: 180 cm / Inseam 84 / Torso 63 / Arm 65 / Road Endurance
//           -> Stack-Target ~579 mm, Reach-Target ~382 mm, Sattel 74.2 cm, Vorbau 100
//   Fit Sheet: Inseam 83.5 / Setback 6.8 cm / Sattel 73.7 cm
//
// Alle Maße intern in mm (Antropometrie-Inputs in cm, *10 wo nötig).

window.WLB_FIT = (function () {

  // ─────────────────────────────────────────────────────────────
  // DISZIPLIN-DATENBANK
  //  ks/kr      : Antropometrie-Koeffizienten (Stack/Reach-Target)
  //  hta/sta    : Lenk-/Sitzrohrwinkel-Zielbereich [°]
  //  frame      : parametrische Rahmen-Geometrie  S/R = base + (h-165)*perCm
  //  stem       : Standard-Vorbaulänge (Mitte) [mm]
  //  barK       : Lenkerbreiten-Logik ('acromial' ± / faktor)
  //  drop       : Sattel-Lenker-Drop [mm] je Niveau {ein, sport, pro}  (+ = Sattel höher)
  //  stack/reach: relative Charakterisierung (Anzeige)
  // ─────────────────────────────────────────────────────────────
  const DISC = {
    road_race: {
      label: "Road Race", group: "Rennrad", nominal: "cm",
      ks: 0.67, kr: 0.385, hta: [72.5, 74], sta: [73, 74],
      frame: { s165: 515, r165: 374, ds: 4.0, dr: 1.55 }, stem: 110,
      barK: { mode: "acromial", off: 0 }, drop: { ein: 30, sport: 65, pro: 110 },
      stackRel: "Ultra-tief", reachRel: "Lang",
      note: "Maximale Aerodynamik. Verlangt hohe lumbale & pelvine Flexibilität.",
    },
    road_endurance: {
      label: "Road Endurance", group: "Rennrad", nominal: "cm",
      ks: 0.69, kr: 0.375, hta: [71.5, 72.5], sta: [73, 73.5],
      frame: { s165: 535, r165: 369, ds: 4.2, dr: 1.35 }, stem: 100,
      barK: { mode: "acromial", off: 0 }, drop: { ein: 10, sport: 40, pro: 70 },
      stackRel: "Hoch", reachRel: "Kurz",
      note: "Entlastet die HWS. Ziel-Rückenwinkel 40–45°.",
    },
    gravel: {
      label: "Gravel", group: "Rennrad", nominal: "cm",
      ks: 0.71, kr: 0.370, hta: [70.5, 71.5], sta: [72.5, 73.5],
      frame: { s165: 545, r165: 364, ds: 4.0, dr: 1.4 }, stem: 90,
      barK: { mode: "acromial", off: 20 }, drop: { ein: 0, sport: 20, pro: 50 },
      stackRel: "Hoch", reachRel: "Moderat",
      note: "Mehr Reifenfreiheit. Breiter Lenker mit Flare.",
    },
    cyclocross: {
      label: "Cyclocross", group: "Rennrad", nominal: "cm",
      ks: 0.70, kr: 0.372, hta: [71, 72], sta: [73, 74],
      frame: { s165: 540, r165: 366, ds: 4.0, dr: 1.45 }, stem: 100,
      barK: { mode: "acromial", off: 0 }, drop: { ein: 5, sport: 25, pro: 50 },
      stackRel: "Moderat", reachRel: "Kurz",
      note: "Höheres Tretlager (weniger BB-Drop) für Hindernisse.",
    },
    triathlon: {
      label: "Triathlon / TT", group: "Rennrad", nominal: "cm",
      ks: 0.66, kr: 0.390, hta: [72, 73.5], sta: [78, 81],
      frame: { s165: 510, r165: 378, ds: 4.0, dr: 1.6 }, stem: 90,
      barK: { mode: "acromial", off: -20 }, drop: { ein: 40, sport: 75, pro: 120 },
      stackRel: "Ultra-tief", reachRel: "Lang",
      note: "Steiles Sitzrohr (78–81°) für die Aero-Position auf dem Lenkeraufsatz. Entlastet die Beine fürs Laufen.",
    },
    mtb_xc: {
      label: "MTB XC", group: "Mountainbike", nominal: "sl",
      ks: 0.70, kr: 0.410, hta: [67, 69], sta: [74, 75],
      frame: { s165: 582, r165: 405, ds: 2.8, dr: 4.0 }, stem: 60,
      barK: { mode: "factor", k: 1.65 }, drop: { ein: -10, sport: 20, pro: 50 },
      stackRel: "Tief/Mod", reachRel: "Lang",
      note: "Vorbauten 60–80 mm. Optimiert Traktion bergauf.",
    },
    mtb_trail: {
      label: "MTB Trail", group: "Mountainbike", nominal: "sl",
      ks: 0.72, kr: 0.400, hta: [65, 66.5], sta: [76, 77],
      frame: { s165: 600, r165: 420, ds: 3.0, dr: 4.5 }, stem: 45,
      barK: { mode: "factor", k: 1.68 }, drop: { ein: -20, sport: -5, pro: 20 },
      stackRel: "Hoch", reachRel: "Sehr lang",
      note: "Ultrakurze Vorbauten (35–50 mm). Technische Kontrolle.",
    },
    mtb_enduro: {
      label: "MTB Enduro", group: "Mountainbike", nominal: "sl",
      ks: 0.73, kr: 0.395, hta: [63.5, 64.5], sta: [77, 78],
      frame: { s165: 615, r165: 430, ds: 3.2, dr: 4.8 }, stem: 40,
      barK: { mode: "factor", k: 1.70 }, drop: { ein: -25, sport: -10, pro: 10 },
      stackRel: "Sehr hoch", reachRel: "Extrem",
      note: "Vario-Sattelstütze mit langem Hub unverzichtbar.",
    },
    trekking: {
      label: "Trekking", group: "Alltag & E-Bike", nominal: "sl",
      ks: 0.72, kr: 0.355, hta: [69, 71], sta: [71, 72.5],
      frame: { s165: 590, r165: 380, ds: 4.0, dr: 1.2 }, stem: 90,
      barK: { mode: "acromial", off: 20 }, drop: { ein: -30, sport: -15, pro: 0 },
      stackRel: "Sehr hoch", reachRel: "Sehr kurz",
      note: "Aufrechte Haltung. Rückenwinkel > 55°.",
    },
    city: {
      label: "City Bike", group: "Alltag & E-Bike", nominal: "sl",
      ks: 0.74, kr: 0.345, hta: [68, 70], sta: [68, 70],
      frame: { s165: 610, r165: 360, ds: 4.2, dr: 1.0 }, stem: 80,
      barK: { mode: "acromial", off: 40 }, drop: { ein: -50, sport: -35, pro: -20 },
      stackRel: "Extrem", reachRel: "Ultra-kurz",
      note: "Gewicht hinten. Breiter Sattel, reine Sitzbein-Auflage.",
    },
    ebike_urban: {
      label: "E-Bike Urban", group: "Alltag & E-Bike", nominal: "sl",
      ks: 0.74, kr: 0.345, hta: [68, 70], sta: [69, 71],
      frame: { s165: 615, r165: 360, ds: 4.2, dr: 1.0 }, stem: 80,
      barK: { mode: "acromial", off: 40 }, drop: { ein: -50, sport: -35, pro: -20 },
      stackRel: "Extrem", reachRel: "Ultra-kurz",
      note: "Höheres Strukturgewicht — maximale Stabilität im Stand. Steileres STA.",
    },
    cargo: {
      label: "Cargo Bike", group: "Alltag & E-Bike", nominal: "sl",
      ks: 0.72, kr: 0.350, hta: [68, 69], sta: [70, 72],
      frame: { s165: 600, r165: 375, ds: 3.5, dr: 1.2 }, stem: 80,
      barK: { mode: "acromial", off: 30 }, drop: { ein: -45, sport: -30, pro: -15 },
      stackRel: "Variabel", reachRel: "Kurz",
      note: "Langer Radstand. Niedriger Standover ist kritisch.",
    },
    kids: {
      label: "Kinder", group: "Spezial", nominal: "sl",
      ks: 0.70, kr: 0.360, hta: [68, 70], sta: [70, 72],
      frame: { s165: 520, r165: 350, ds: 4.0, dr: 1.5 }, stem: 60,
      barK: { mode: "acromial", off: 0 }, drop: { ein: -20, sport: -10, pro: 0 },
      stackRel: "Hoch", reachRel: "Kurz",
      note: "Dynamische Anpassung per Wachstumsfaktor. Schmaler Q-Faktor.",
    },
    senior: {
      label: "Senioren / Mob. eingeschr.", group: "Spezial", nominal: "sl",
      ks: 0.74, kr: 0.340, hta: [68, 70], sta: [68, 70],
      frame: { s165: 620, r165: 350, ds: 4.0, dr: 0.9 }, stem: 80,
      barK: { mode: "acromial", off: 40 }, drop: { ein: -55, sport: -45, pro: -35 },
      stackRel: "Maximal", reachRel: "Minimal",
      note: "Step-through-Rahmen ohne Oberrohr. Kniebeugung minimieren.",
    },
  };

  const DISC_ORDER = [
    "road_race", "road_endurance", "gravel", "cyclocross", "triathlon",
    "mtb_xc", "mtb_trail", "mtb_enduro",
    "trekking", "city", "ebike_urban",
    "kids",
  ];

  // Wofür ist welche Disziplin? (Kurzbeschreibung für die Auswahl)
  const DISC_USE = {
    road_race:      "Wettkampf auf Asphalt. Maximale Aerodynamik & Effizienz — sportlich gestreckte Haltung.",
    road_endurance: "Lange Asphalt-Touren mit Komfort. Aufrechter & rückenschonend — Gran Fondo, Vielfahrer.",
    gravel:         "Asphalt, Schotter & Waldwege. Robust, breite Reifen, bikepacking-tauglich.",
    cyclocross:     "Querfeldein-Rennen im Gelände. Wendig, hohes Tretlager, leicht zum Schultern.",
    triathlon:      "Zeitfahren & Triathlon. Aero-Position auf dem Aufsatz, steiles Sitzrohr — maximale Geschwindigkeit auf Asphalt.",
    mtb_xc:         "Marathon & Cross-Country. Leicht und effizient bergauf, kurze Federung.",
    mtb_trail:      "Allround-Trails & Singletrails. Verspielt, mehr Federweg, viel Kontrolle.",
    mtb_enduro:     "Ruppige Abfahrten & Bikepark. Maximaler Federweg, klar abfahrtsorientiert.",
    trekking:       "Alltag, Pendeln & Reise. Schutzbleche, Gepäckträger, aufrecht & komfortabel.",
    city:           "Kurze Stadtwege. Sehr aufrecht und bequem, alltagstauglich mit Licht & Korb.",
    ebike_urban:    "Pendeln mit Rückenwind. Aufrecht, kippstabil, Motor & Akku integriert.",
    cargo:          "Lasten & Kinder transportieren. Langer Radstand, sehr stabil, hohe Zuladung.",
    kids:           "Kinder & Jugendliche. Leicht, schmaler Q-Faktor, mitwachsende Geometrie.",
    senior:         "Sicher & gelenkschonend. Tiefer Einstieg (Step-through), sehr aufrechte Haltung.",
  };

  // Nominal-Größentabelle
  const SIZE_BANDS = [
    { max: 162, letter: "XS", cm: 48 },
    { max: 170, letter: "S",  cm: 51 },
    { max: 178, letter: "M",  cm: 54 },
    { max: 186, letter: "L",  cm: 56 },
    { max: 194, letter: "XL", cm: 58 },
    { max: 999, letter: "XXL", cm: 61 },
  ];

  // ─────────────────────────────────────────────────────────────
  // Hilfsfunktionen
  // ─────────────────────────────────────────────────────────────
  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
  const round = (v) => Math.round(v);
  const mid = (arr) => (arr[0] + arr[1]) / 2;

  // Kurbellänge nach Inseam-Band (mm)
  function crankLength(inseam) {
    if (inseam < 75) return 165;
    if (inseam < 80) return 167.5;
    if (inseam < 85) return 170;
    if (inseam < 90) return 172.5;
    return 175;
  }

  // Lenkerbreite (mm), gerundet auf 10 mm
  function barWidth(disc, acromial) {
    const d = DISC[disc];
    let w;
    if (d.barK.mode === "factor") w = acromial * 10 * d.barK.k;
    else w = acromial * 10 + d.barK.off;
    return round(w / 10) * 10;
  }

  // Setback (mm) — kalibriert auf Fit-Sheet (Inseam 83.5 / Femur 44 -> 68 mm)
  function setback(inseam, femur) {
    return round(inseam * 0.62 + femur * 0.38) * 10 / 10; // mm
  }

  // ─────────────────────────────────────────────────────────────
  // Modifikatoren-Matrix (Strategie-Guide Abschnitt 4)
  // ─────────────────────────────────────────────────────────────
  function modifiers(s) {
    let dS = 0, dR = 0;
    const notes = [];
    // Flexibilität (Sit & Reach)
    if (s.flex === "low")  { dS += 20; dR -= 15; notes.push(["Flexibilität niedrig", "+20 / −15"]); }
    if (s.flex === "high") { dS -= 15; dR += 10; notes.push(["Flexibilität hoch", "−15 / +10"]); }
    // Hüftmobilität
    if (s.hip === "limited") { dS += 15; dR -= 10; notes.push(["Hüftmobilität eingeschränkt", "+15 / −10"]); }
    // Beschwerden
    if (s.injLumbar)   { dS += 25; dR -= 20; notes.push(["LWS / Bandscheibe", "+25 / −20"]); }
    if (s.injCervical) { dS += 25; dR -= 20; notes.push(["HWS / Nacken", "+25 / −20"]); }
    // Alter
    if (s.age > 55) { dS += 15; dR -= 8; notes.push(["Alter > 55", "+15 / −8"]); }
    // Sitzhaltung
    if (s.posture === "aggressive") { dS -= 10; dR += 15; notes.push(["Haltung aggressiv", "−10 / +15"]); }
    if (s.posture === "comfort")    { dS += 20; dR -= 15; notes.push(["Haltung komfortabel", "+20 / −15"]); }
    return { dS, dR, notes };
  }

  // ─────────────────────────────────────────────────────────────
  // HAUPT-BERECHNUNG
  // ─────────────────────────────────────────────────────────────
  function compute(s) {
    const d = DISC[s.disc];

    // 1 · Sattelhöhe
    const hsLemond  = s.inseam * 0.883;   // cm
    const hsGuimard = s.inseam * 0.885;   // cm

    // 2 · Basis-Targets (mm)
    //   Stack: Inseam[cm] × Ks × 10  → mm  (Guide §2, deckt sich mit Caso A: 84×0.69 = 579)
    //   Reach: (Torso+Arm)[cm] × Kr × Kcorr  — empirischer Korrekturfaktor 0.795,
    //   da nur ein Teil der Rumpf+Arm-Länge in effektiven Reach übergeht
    //   (Guide §2 roh = 480 mm, real angepasst auf 382 mm bei Caso A → Kcorr).
    const REACH_KCORR = 7.95;
    const stackBase = s.inseam * d.ks * 10;
    const reachBase = (s.torso + s.arm) * d.kr * REACH_KCORR;

    // 3 · Modifikatoren
    const mod = modifiers(s);
    const stackTarget = round(stackBase + mod.dS);
    const reachTarget = round(reachBase + mod.dR);

    // 4 · Rahmen-Geometrie (parametrisch nach Größe)
    const frameStack = round(d.frame.s165 + (s.height - 165) * d.frame.ds);
    const frameReach = round(d.frame.r165 + (s.height - 165) * d.frame.dr);
    const dStack = stackTarget - frameStack;   // + => Spacer nötig
    const dReach = reachTarget - frameReach;   // + => längerer Vorbau

    // 5 · Nominalgröße
    const band = SIZE_BANDS.find((b) => s.height < b.max) || SIZE_BANDS[SIZE_BANDS.length - 1];
    const nominal = d.nominal === "cm" ? `${band.cm}` : band.letter;

    // 6 · Komponenten-Kompensation
    const spacers = clamp(round(dStack), -25, 60);          // mm unter Vorbau
    const stemStd = d.stem;
    const stemFinal = clamp(round(stemStd + dReach), 35, 140);
    const crank = crankLength(s.inseam);
    const bar = barWidth(s.disc, s.acromial);
    const setbk = setback(s.inseam, s.femur);

    // 7 · Drop (Sattel-Lenker) nach Niveau
    const dropTarget = d.drop[s.level];

    // 8 · Winkel-Targets
    const staT = mid(d.sta);
    const htaT = mid(d.hta);

    // 9 · Confidence Score
    const cs = confidence(s, { spacers, stemFinal, dStack, dReach });

    // 10 · Red Flags / Diagnose
    const flags = redFlags(s, { spacers, stemFinal, dStack, dReach });

    return {
      disc: d, discId: s.disc,
      hsLemond, hsGuimard,
      stackBase: round(stackBase), reachBase: round(reachBase),
      stackTarget, reachTarget,
      frameStack, frameReach, dStack, dReach,
      band, nominal,
      spacers, stemStd, stemFinal, crank, bar, setbk,
      dropTarget, staT, htaT,
      mod, cs, flags,
    };
  }

  // Confidence Score (Strategie-Guide Abschnitt 5)
  function confidence(s, c) {
    let cs = 100;
    const reasons = [];
    // Beschwerden-Strafe
    if (s.injLumbar)   { cs -= 12; reasons.push(["LWS-Beschwerden", -12]); }
    if (s.injCervical) { cs -= 10; reasons.push(["HWS-Beschwerden", -10]); }
    if (s.hip === "limited") { cs -= 5; reasons.push(["Hüftmobilität", -5]); }
    if (s.age > 60)    { cs -= 6; reasons.push(["Alter > 60", -6]); }
    // Antropometrie-Abweichung (Inseam/Größe-Ratio Norm 0.466)
    const ratio = s.inseam / s.height;
    const dev = Math.abs(ratio - 0.466);
    const pAnthro = Math.min(20, round(dev * 420));
    if (pAnthro > 0) { cs -= pAnthro; reasons.push(["Proportions-Abweichung", -pAnthro]); }
    // Kompensations-Strafe
    if (c.spacers > 35)  { cs -= 10; reasons.push(["Spacer > 35 mm", -10]); }
    if (Math.abs(c.dReach) > 25) { cs -= 8; reasons.push(["Reach-Abweichung > 25 mm", -8]); }
    if (c.stemFinal < 70 && DISC[s.disc].group === "Rennrad") { cs -= 8; reasons.push(["Vorbau < 70 mm (Road)", -8]); }
    cs = clamp(cs, 35, 100);
    return { value: cs, reasons, referral: cs < 75 };
  }

  // Red Flags (Strategie-Guide Abschnitt 6)
  function redFlags(s, c) {
    const out = [];
    if (c.spacers > 40) out.push({
      level: "danger", title: "Spacer > 40 mm",
      body: "Rahmen-Stack deutlich zu niedrig. Strukturrisiko am Carbon-Steuerrohr — größere Rahmenhöhe wählen.",
    });
    else if (c.spacers > 35) out.push({
      level: "warn", title: "Spacer 35–40 mm",
      body: "Grenzbereich. Steifigkeit des Gabelschafts beachten, ggf. eine Nummer größer.",
    });
    if (c.stemFinal < 70 && DISC[s.disc].group === "Rennrad") out.push({
      level: "danger", title: "Vorbau < 70 mm (Road)",
      body: "Lenkverhalten wird nervös (twitchy). Rahmen zu lang (Reach-Überschuss) — kleinere Größe prüfen.",
    });
    if (c.dStack < -25) out.push({
      level: "warn", title: "Stack-Überschuss",
      body: "Gewünschter Drop kaum erreichbar; Untersteuern durch fehlende Last vorn. Sportlichere Geometrie wählen.",
    });
    if (Math.abs(c.dReach) > 30) out.push({
      level: "warn", title: "Reach stark abweichend",
      body: "Vorbau-Kompensation am Limit. Sattel droht ganz vor/zurück auf der Schiene — STA bzw. Rahmenlänge prüfen.",
    });
    return out;
  }

  return { DISC, DISC_ORDER, DISC_USE, SIZE_BANDS, compute, crankLength, barWidth, setback };
})();
